
import React from 'react';
import { createPortal } from 'react-dom';
import { Puzzle } from '../types';
import { usePuzzles } from '../PuzzleContext';
import { Capacitor } from '@capacitor/core';

interface ShareModalProps {
    isOpen: boolean;
    onClose: () => void;
    puzzle: Puzzle;
    triggerRect: DOMRect | null;
}

const ShareModal: React.FC<ShareModalProps> = ({ isOpen, onClose, puzzle }) => {
    const { sharePuzzleToFeed, repostPuzzle } = usePuzzles();

    const handleCopyLink = () => {
        // SMART LINKING:
        // If on Web: Use current URL (window.location.origin)
        // If on Mobile (Native): Hardcode the live web URL so friends can open it
        const isNative = Capacitor.isNativePlatform();
        const baseUrl = isNative 
            ? 'https://what-was-it-gc-fb-56459.web.app' 
            : window.location.origin;
            
        const link = `${baseUrl}/?post=${puzzle.id}`;
        
        navigator.clipboard.writeText(link);
        alert('Link copied! Send it to a friend.');
        onClose();
    };

    const handleShare = () => {
        sharePuzzleToFeed(puzzle.id);
        onClose();
    };
    
    const handleRepost = () => {
        repostPuzzle(puzzle.id);
        onClose();
    };

    if (!isOpen) return null;

    return createPortal(
        <div className="fixed inset-0 bg-black/50 z-[9999] flex items-center justify-center p-4" onClick={onClose}>
            <div className="bg-white p-4 rounded-lg shadow-xl w-full max-w-sm text-gray-800" onClick={e => e.stopPropagation()}>
                <h2 className="text-xl font-bold mb-4 text-center">Share</h2>
                <div className="space-y-2">
                    <button onClick={handleShare} className="w-full text-left p-3 flex items-center gap-3 hover:bg-gray-100 rounded-lg">
                        <i className="ph-duotone ph-share-network text-2xl text-purple-500"></i>
                        <span className="font-semibold">Share to your Feed</span>
                    </button>
                    <button onClick={handleRepost} className="w-full text-left p-3 flex items-center gap-3 hover:bg-gray-100 rounded-lg">
                        <i className="ph-duotone ph-repeat text-2xl text-emerald-500"></i>
                        <span className="font-semibold">Repost</span>
                    </button>
                    <button onClick={handleCopyLink} className="w-full text-left p-3 flex items-center gap-3 hover:bg-gray-100 rounded-lg">
                        <i className="ph-duotone ph-link text-2xl text-blue-500"></i>
                        <span className="font-semibold">Copy Link</span>
                    </button>
                </div>
                <button onClick={onClose} className="w-full mt-4 py-2 text-gray-500 font-semibold">Close</button>
            </div>
        </div>,
        document.body
    );
};

export default ShareModal;
